export default "__VITE_ASSET__da9bb29e__"